import React from 'react'

import { ContributionSummarySection } from './ContributionSummarySection/ContributionSummarySection'
import * as S from './styled'
import type { Props } from './types'

export const ContributionSummary = ({ title, subtitle, description, status, children }: Props) => (
  <S.Container>
    <S.Header>
      <S.Content>
        {description && <S.Description>{description}</S.Description>}
        {title && <S.Title>{title}</S.Title>}
        {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}
      </S.Content>
      {status && <div>{status}</div>}
    </S.Header>
    {children}
  </S.Container>
)

ContributionSummary.Section = ContributionSummarySection
